<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-10">
            Talent Profiling Guide
        </div>
        <div class="content margin-bottom-10">
            <a href="/question-set-a">
                <img :src="'images/mpower-new/career/back-arrow.png'" />
            </a>
        </div>
        <div class="content">
            <div class="talent-question-title margin-bottom-10 text-left">
                {{data[loadIndex].title}}
            </div>
            <div class="talent-question-desc line-height-normal text-left">
                {{data[loadIndex].description}} 
            </div>
        </div>
        <div class="content" v-for="(item,index) in data[loadIndex].question" :key="index">
            <div class="talent-category margin-bottom-10 text-left">
                {{item.section}}
            </div>
            <div v-for="(subitem,index) in item.question" :key="index">
                <div class="talent-left-wrapper">
                    <label class="talent-label text-left">
                        {{subitem.title}}
                    </label>
                </div>
                <div class="talent-right-wrapper">

                    <label v-if="item.section.toLowerCase()=='l' && subitem.index!='10'" :class="setl.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="setl" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_g[]" @change="check(setl,'g')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='l' && subitem.index=='10'" class="talent-option talent-option-text total_number_g">
                        <input v-model="setl" class="custom-input-text total_number_g" type="number" name='total_number_g' readonly>
                    </label>

                    <label v-if="item.section.toLowerCase()=='t' && subitem.index!='10'" :class="sett.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="sett" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_e[]" @change="check(sett,'e')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='t' && subitem.index=='10'" class="talent-option talent-option-text total_number_e">
                        <input v-model="sett" class="custom-input-text total_number_e" type="number" name='total_number_e' readonly>
                    </label>

                    <label v-if="item.section.toLowerCase()=='p' && subitem.index!='10'" :class="setp.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="setp" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_n[]" @change="check(setp,'n')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='p' && subitem.index=='10'" class="talent-option talent-option-text total_number_n">
                        <input v-model="setp" class="custom-input-text total_number_n" type="number" name='total_number_n' readonly>
                    </label>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="talent-button-wrapper">
            <a class="generali-button-red" @click="proceed()">
                {{data[loadIndex].button}}
            </a>
        </div>
    </div>
</template>
<style scoped>
</style>
<script>
export default {
    name: "Question_set_b",
    data(){
        return {
            setl: [],
            sett: [],
            setp: [],
            conclusion: {},
            loadIndex: 0,
            data: [{
                "language": "en",
                "title": "I. Interest",
                "description": "Place a tick ( ✔ ) in the box against those items that really interest you. You can tick as many as you want.",
                "question": [{
                    "section": "L",
                    "question": [{
                        "index": 1,
                        "title": "Write letters to friends"
                    },{
                        "index": 2,
                        "title": "Belong to social clubs"
                    },{
                        "index": 3,
                        "title": "Help others with personal problems"
                    },{
                        "index": 4,
                        "title": "Take care of children"
                    },{
                        "index": 5,
                        "title": "Go to parties or dance"
                    },{
                        "index": 6,
                        "title": "Read psychology books"
                    },{
                        "index": 7,
                        "title": "Attend meetings and conferences"
                    },{
                        "index": 8,
                        "title": "Go to sports events"
                    },{
                        "index": 9,
                        "title": "Make new friends"
                    },{
                        "index": 10,
                        "title": "TOTAL no. of ticks"
                    }]
                },{
                    "section": "T",
                    "question": [{
                        "index": 1,
                        "title": "Influence others"
                    },{
                        "index": 2,
                        "title": "Sell something"
                    },{
                        "index": 3,
                        "title": "Discuss politics"
                    },{
                        "index": 4,
                        "title": "Operate my own service or business"
                    },{
                        "index": 5,
                        "title": "Attend conferences"
                    },{
                        "index": 6,
                        "title": "Give talks"
                    },{
                        "index": 7,
                        "title": "Supervise the work of others"
                    },{
                        "index": 8,
                        "title": "Meet important people"
                    },{
                        "index": 9,
                        "title": "Lead a group to achieve a goal"
                    },{
                        "index": 10,
                        "title": "TOTAL no. of ticks"
                    }]
                },{
                    "section": "P",
                    "question": [{
                        "index": 1,
                        "title": "Keep your desk and room neat"
                    },{
                        "index": 2,
                        "title": "Type papers or letters"
                    },{
                        "index": 3,
                        "title": "Perform financial calculations"
                    },{
                        "index": 4,
                        "title": "Operate business machines of any kind"
                    },{
                        "index": 5,
                        "title": "Keep detailed records of expenses"
                    },{
                        "index": 6,
                        "title": "Take business writing course"
                    },{
                        "index": 7,
                        "title": "Take business course"
                    },{
                        "index": 8,
                        "title": "Take commercial mathematic course"
                    },{
                        "index": 9,
                        "title": "File letters, reports, records etc"
                    },{
                        "index": 10,
                        "title": "TOTAL no. of ticks"
                    }]
                }],
                "answer": "Yes",
                "button": "Proceed"
            },{
                "language": "cn",
                "title": "I. 兴趣",
                "description": "在那些你感兴趣的领域里画 （ ✔ ）。 你可以选择超过一个。",
                "question": [{
                    "section": "L",
                    "question": [{
                        "index": 1,
                        "title": "写信给朋友"
                    },{
                        "index": 2,
                        "title": "成为社团成员"
                    },{
                        "index": 3,
                        "title": "乐于向有难者伸出援手"
                    },{
                        "index": 4,
                        "title": "关心儿童"
                    },{
                        "index": 5,
                        "title": "参加派对或舞会"
                    },{
                        "index": 6,
                        "title": "阅读心理学书籍"
                    },{
                        "index": 7,
                        "title": "出席会议和研讨会"
                    },{
                        "index": 8,
                        "title": "热衷运动项目"
                    },{
                        "index": 9,
                        "title": "结交新朋友"
                    },{
                        "index": 10,
                        "title": "✔ 的数量"
                    }]
                },{
                    "section": "T",
                    "question": [{
                        "index": 1,
                        "title": "影响他人"
                    },{
                        "index": 2,
                        "title": "买卖商品"
                    },{
                        "index": 3,
                        "title": "谈论政治"
                    },{
                        "index": 4,
                        "title": "经营本身的服务事业或生意"
                    },{
                        "index": 5,
                        "title": "出席研讨会"
                    },{
                        "index": 6,
                        "title": "演讲"
                    },{
                        "index": 7,
                        "title": "监督他人工作"
                    },{
                        "index": 8,
                        "title": "接见重要人物"
                    },{
                        "index": 9,
                        "title": "带领团队完成目标"
                    },{
                        "index": 10,
                        "title": "✔ 的数量"
                    }]
                },{
                    "section": "P",
                    "question": [{
                        "index": 1,
                        "title": "保持桌面和房间干净整洁"
                    },{
                        "index": 2,
                        "title": "打文件或信件"
                    },{
                        "index": 3,
                        "title": "执行财务计算"
                    },{
                        "index": 4,
                        "title": "操作任何种类的商业机械"
                    },{
                        "index": 5,
                        "title": "存档消费的记录"
                    },{
                        "index": 6,
                        "title": "修读商务写作课程"
                    },{
                        "index": 7,
                        "title": "修读商业课程"
                    },{
                        "index": 8,
                        "title": "修读商业数学课程"
                    },{
                        "index": 9,
                        "title": "将信件、报告和记录等归档"
                    },{
                        "index": 10,
                        "title": "✔ 的数量"
                    }]
                }],
                "answer": "是",
                "button": "继续"
            },{
                "language": "bm",
                "title": "I. Minat",
                "description": "Sila tanda ( ✔ ) di dalam kotak terhadap semua perkara-perkara yang anda berminat. Anda boleh tanda seberapa banyak yang anda mahu.",
                "question": [{
                    "section": "L",
                    "question": [{
                        "index": 1,
                        "title": "Menulis surat kepada kawan-kawan"
                    },{
                        "index": 2,
                        "title": "Menyertai kelab-kelab sosial"
                },{
                        "index": 3,
                        "title": "Membantu orang lain dengan masalah peribadi"
                    },{
                        "index": 4,
                        "title": "Menjaga kanak-kanak"
                    },{
                        "index": 5,
                        "title": "Menyertai parti atau tarian"
                    },{
                        "index": 6,
                        "title": "Membaca buku-buku psikologi"
                    },{
                        "index": 7,
                        "title": "Menghadiri mesyuarat dan persidangan"
                    },{
                        "index": 8,
                        "title": "Menyertai acara sukan"
                    },{
                        "index": 9,
                        "title": "Mengenali kawan baru"
                    },{
                        "index": 10,
                        "title": "Bilangan ✔"
                    }]
                },{
                    "section": "T",
                    "question": [{
                        "index": 1,
                        "title": "Mempengaruhi orang lain"
                    },{
                        "index": 2,
                        "title": "Menjual sesuatu"
                    },{
                        "index": 3,
                        "title": "Bincang politik"
                    },{
                        "index": 4,
                        "title": "Mengendalikan perkhidmatan atau perniagaan saya sendiri"
                    },{
                        "index": 5,
                        "title": "Menghadiri persidangan"
                    },{
                        "index": 6,
                        "title": "Memberi ceramah"
                    },{
                        "index": 7,
                        "title": "Menyelia kerja orang lain"
                    },{
                        "index": 8,
                        "title": "Bertemu orang penting"
                    },{
                        "index": 9,
                        "title": "Memimpin satu kumpulan untuk mencapai matlamat"
                    },{
                        "index": 10,
                        "title": "Bilangan ✔"
                    }]
                },{
                    "section": "P",
                    "question": [{
                        "index": 1,
                        "title": "Mengekalkan meja dan bilik anda teratur"
                    },{
                        "index": 2,
                        "title": "Menaip kertas atau surat"
                    },{
                        "index": 3,
                        "title": "Menjalankan pengiraan kewangan"
                    },{
                        "index": 4,
                        "title": "Mengendalikan apa-apa jenis mesin perniagaan"
                    },{
                        "index": 5,
                        "title": "Menyimpan rekod-rekod terperinci perniagaan"
                    },{
                        "index": 6,
                        "title": "Mengambil kursus penulisan perniagaan"
                    },{
                        "index": 7,
                        "title": "Mengambil kursus perniagaan"
                    },{
                        "index": 8,
                        "title": "Mengambil kursus matematik komersial"
                    },{
                        "index": 9,
                        "title": "Menfailkan surat-surat, laporan, rekod dan lain-lain"
                    },{
                        "index": 10,
                        "title": "Bilangan ✔"
                    }]
                }],
                "answer": "Ya",
                "button": "Teruskan"
            }]
        }
    },
    mounted(){
        if(localStorage.getItem('talent_test')){
            try{
                this.conclusion = JSON.parse(localStorage.getItem('talent_test'))
                for(var a = 0; a < this.data.length; a++){
                    if(this.conclusion.language==this.data[a].language){
                        this.loadIndex = a
                    }
                }
            }
            catch(e){
                console.log(e)
                localStorage.removeItem('talent_test')
            }
        }
    },
    methods: {
        check(set,setname) {
            this.$el.querySelector(".total_number_"+setname).innerText = set.length;
        },
        proceed(){
            this.conclusion.l1 = 0;
            this.conclusion.t1 = 0;
            this.conclusion.p1 = 0;

            if(this.setl.length > 0){
                for(var a = 0 ; a < this.setl.length; a++){
                    this.conclusion.l1 += 1;
                }   
            }
            if(this.sett.length > 0){
                for(var b = 0; b < this.sett.length; b++){
                    this.conclusion.t1 += 1;
                }
            }
            if(this.setp.length > 0){
                for(var c = 0; c < this.setp.length; c++){
                    this.conclusion.p1 += 1;
                }
            }
            console.log(this.conclusion)
            localStorage.setItem('talent_test',JSON.stringify(this.conclusion))
            window.scrollTo(0,0);
            this.$router.push({path: 'question-set-c'})
        },
        scrollToTop() {
            window.scrollTo(0,0);
        }
    },
}
</script>